import { Button, Input } from "antd";
import "../../index.css";
import "./Auth.css";
import { Controller, useForm } from "react-hook-form";
import apiService from "../../services/apiService";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router";
import { encryptData } from "../../utils";

type FormValues = {
  new_password: string;
  confirm_password?: string;
};
const ResetPassword = () => {
  let { id } = useParams();
  const {
    control,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<FormValues>({
    mode: "onBlur", // Validation triggered on blur
  });

  const newPassword = watch("new_password");
  const email = localStorage.getItem("email");

  const navigate = useNavigate();

  const onSubmit = async (data: FormValues) => {
    try {
      // Encrypt new password before sending
      const encryptedPassword = encryptData(data.new_password);

      if (id === "" || id === undefined) {
        const response: {
          token: string;
          message: string;
        } = await apiService.post("/auth/reset-password", {
          newPassword: encryptedPassword,
          email,
        });
        if (response) {
          toast.success(response.message);
          navigate("/login");
          return;
        }
      } else {
        const response: {
          token: string;
          message: string;
        } = await apiService.post("/users/reset-password", {
          newPassword: encryptedPassword,
          resetLink: id,
        });
        if (response) {
          toast.success(response.message);
          navigate("/login");
        }
      }
    } catch (error: any) {
      toast.error(error.message ? error.message : error);
    }
  };
  return (
    <>
      <div className="login-container container">
        <div className="reset-password-form">
          <div className="form-header login-header">Reset your password</div>
          {/* <div style={{ paddingTop: "20px" }}>
                        <div className="form-label login-label">New Password</div>
                        <Input.Password size="large" style={{ height: "48px", borderRadius: "4px" }} />
                    </div> */}
          <form onSubmit={handleSubmit(onSubmit)}>
            <div style={{ paddingTop: "20px" }}>
              <div className="form-label login-label">New Password</div>
              <Controller
                name="new_password"
                control={control}
                rules={{
                  required: "Please enter your password!",
                }}
                render={({ field }) => (
                  <Input.Password
                    {...field}
                    size="large"
                    className={
                      errors.new_password ? "ant-input-status-error" : ""
                    }
                    style={{ height: "48px", borderRadius: "4px" }}
                  />
                )}
              />
              {errors.new_password && (
                <div className="ant-form-item-explain-error">
                  {errors.new_password.message}
                </div>
              )}
            </div>
            {/* <div style={{ paddingTop: "30px" }}>
                        <div className="form-label login-label">Confirm Password</div>
                        <Input.Password size="large" style={{ height: "48px", borderRadius: "4px" }} />
                    </div> */}
            {!id && (
              <div style={{ paddingTop: "30px" }}>
                <div className="form-label login-label">Confirm Password</div>
                <Controller
                  name="confirm_password"
                  control={control}
                  rules={{
                    required: "Please enter your password!",
                    validate: (value) =>
                      value === newPassword || "Passwords do not match!",
                  }}
                  render={({ field }) => (
                    <Input.Password
                      {...field}
                      size="large"
                      className={
                        errors.confirm_password ? "ant-input-status-error" : ""
                      }
                      style={{ height: "48px", borderRadius: "4px" }}
                    />
                  )}
                />
                {errors.confirm_password && (
                  <div className="ant-form-item-explain-error">
                    {errors.confirm_password.message}
                  </div>
                )}
              </div>
            )}
            <div style={{ paddingTop: "30px" }}>
              <Button
                color="primary"
                variant="solid"
                size="large"
                className="form-button"
                htmlType="submit"
              >
                Reset your password
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
